import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import cx from "classnames";
import useBreakpoint from "utils/hooks/useBreakpoint";
import breakpoints from "utils/breakpoints";
import HeartIcon from "components/icons/Heart";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "tailwind.config.js";
import HeartFilled from "components/icons/HeartFilled";
import useFavorites from "utils/hooks/useFavorites";

const fullConfig = resolveConfig(tailwindConfig);

const Container = styled.div`
  width: 17rem;
`;

const IconContainer = styled.div`
  width: 1.75rem;
  height: 1.75rem;
`;

const Content = styled.div`
  transition: all 0.4s ease-out;
  height: auto;
`;

const ImageContainer = styled.div`
  height: 11rem;
`;

const CardTitle = styled.div`
  letter-spacing: -0.029rem;
`;

const CardSubtitle = styled.div`
  letter-spacing: 0.007rem;
`;

const AvailableFlag = styled.div`
  border-radius: 0.813rem;
  width: fit-content;
`;

const getCommunityStylesFormat = (communityStyles) => {
  const styles = communityStyles.split(",");
  if (styles && styles.length > 1) {
    let newFormat = styles.reduce(function (a, b) {
      return a.concat(", " + b);
    });
    return newFormat;
  }

  return communityStyles;
};
const getCity = (text) => {
  const city = text.split(",");
  if (city && city.length > 1) {
    return city[0] || "";
  }
  return "";
};

const MapCommunityCard = (props) => {
  const {
    id,
    imageAlt,
    imageUrl,
    subtitle,
    stateAbbrev,
    title,
    communityCardIcon,
    communityStyles,
    paragraph,
    startingFrom,
    startingFromLabel,
    noPriceText,
    ctas,
  } = props;

  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);
  const url = ctas && ctas.length > 0 && ctas[0] && ctas[0].href;

  const { favoritesList, saveFavorite, deleteFavorite } = useFavorites();
  const isFavorite = favoritesList.includes(id);
  const handleFavoriteClick = (id) => {
    if (!isFavorite) {
      saveFavorite(id);
    } else {
      deleteFavorite(id);
    }
  };

  return (
    <Container
      className={
        "relative w-full flex flex-col justify-between overflow-hidden rounded transform"
      }
      id={"InfoWindow-" + id}
    >
      <Content className="md:cursor-pointer z-20 bg-white" isMobile={isMobile}>
        <ImageContainer>
          <a
            href={url}
            className="h-full w-full relative"
            aria-label={"View " + title + " information"}
          >
            <img
              className="object-cover h-full min-w-full"
              src={imageUrl}
              alt={imageAlt}
            />
          </a>
          <IconContainer
            className="flex items-center absolute top-0 right-0 justify-center
                rounded-full bg-white text-action-blue mt-10-mattamy mr-3 hover:bg-mattamy-blue
                hover:text-white md:cursor-pointer"
            onClick={() => handleFavoriteClick(id)}
            role="button"
            aria-label={isFavorite ? "Mark as unfavorite" : "Mark as favorite"}
            aria-pressed={isFavorite ? "true" : "false"}
            tabIndex={0}
          >
            {isFavorite ? (
              <HeartFilled className="h-4 w-4" />
            ) : (
              <HeartIcon className="h-4 w-4" />
            )}
          </IconContainer>
        </ImageContainer>
        <a
          href={url}
          aria-label={"View " + title + "information"}
          className="m-3 flex flex-col w-auto items-left text-left md:items-left "
        >
          <div className="flex flex-row">
            <div className="flex flex-col w-10/12 ">
              <CardSubtitle className="font-graphie text-mattamy-blue-light text-xs leading-5">
                {getCity(subtitle) + ", " + stateAbbrev}
              </CardSubtitle>

              <CardTitle className="font-trade-gothic-20 text-mattamy-blue text-2xl mt-2">
                {title}
              </CardTitle>
            </div>
            <div className="flex w-2/12">
              {communityCardIcon && communityCardIcon.src && (
                <div
                  className="h-10 w-10 flex items-center justify-center
                rounded-full bg-white text-action-blue border-1-5 border-action-blue"
                >
                  <img
                    className="object-cover rounded-full h-full min-w-full"
                    src={communityCardIcon && communityCardIcon.src}
                    alt={communityCardIcon && communityCardIcon.alt}
                  />
                </div>
              )}
            </div>
          </div>

          {communityStyles && (
            <p className="text-mattamy-gray-font text-sm font-trade-gothic-20 text-left font-bold mt-1">
              {getCommunityStylesFormat(communityStyles)}
            </p>
          )}

          {paragraph && (
            <CardSubtitle className="font-graphie text-mattamy-blue-light text-xs leading-5">
              {paragraph}
            </CardSubtitle>
          )}

          {((startingFrom && startingFrom !== "$0" && startingFromLabel) ||
            noPriceText) && (
            <div className="w-full mt-6 h-8 pt-2 rounded block text-center text-sm text-white bg-action-blue font-trade-gothic-20 hover:bg-mattamy-blue leading-5">
              {startingFrom !== "$0"
                ? startingFromLabel + " " + startingFrom
                : noPriceText}
            </div>
          )}
        </a>
      </Content>
    </Container>
  );
};

MapCommunityCard.propTypes = {
  card: PropTypes.object,
};

export default MapCommunityCard;
